import React from 'react';
import PropTypes from 'utils/propTypes';

import classNames from 'classnames';

import { Card, CardBody, CardTitle, CardSubtitle } from 'reactstrap';

const IconWidget = ({
  bgColor,
  icon: Icon,
  iconProps,
  title,
  subtitle,
  className,
  progress,
  active,
  ...restProps
  
}) => {
  const classes = classNames('cr-widget', className, {
    [`bg-${bgColor}`]: bgColor,
    'active':active
  });
  return (
    <Card className={classes} {...restProps}>
      <CardBody className="cr-widget__icon">
        <Icon size={iconProps.size} {...iconProps} />
        {(progress && progress.value) && <div style={{textAlign:'center',fontSize:12}}>{progress.value}%</div>}
      </CardBody>
      <CardBody>
        <CardTitle>{title}</CardTitle>
        <CardSubtitle>{subtitle}</CardSubtitle>
      </CardBody>
    </Card>
  );
};

IconWidget.propTypes = {
  bgColor: PropTypes.string,
  icon: PropTypes.component,
  iconProps: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.number,
  active: PropTypes.bool,
  progress: PropTypes.object,
};

IconWidget.defaultProps = {
  active: false,
  bgColor: 'primary',
  icon: 'span',
  iconProps: { size: 50, style:{color:'#00aee4'} },
  
};

export default IconWidget;
